import { OtpGenerateAdapter } from '../../../adapter';

export default async function OtpGenerateUseCase(event) {
    console.log('OtpGenerateUseCase: ', event);
    const { loanAccountNumber, mobileNo, email, type } = event;

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcr.dev.bpimsapps.com');
    const isUAT = url.includes('hcr.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionrenewal.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/v1/otp/hcr-generate'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/v1/otp/hcr-generate'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/otp/hcr-generate`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/otp/hcr-generate`;

    // prepare data
    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/v1/otp/generate';

    let payload;

    if(Object.keys(event).length == 2 || loanAccountNumber) {
        payload = { coicNo: !!loanAccountNumber ? loanAccountNumber : undefined, type: type ?? 'email'  }
    }

    // handle request
    const result = await OtpGenerateAdapter(endpoint, JSON.stringify(payload));

    return result;
}
